/* eslint-disable no-case-declarations */
import { QueryClientConfig } from "@tanstack/react-query";
import { sentryCaptureError } from "utils/errorFormatter";

import openToast from "utils/openToast";

export const handleGlobalError = async (error: any) => {
  if (error.status) {
    switch (error.status) {
      case 401:
        // Handle unauthenticated access
        openToast(
          "Unauthorized request denied. Please contact support.",
          "error",
        );
        if ("is_expired" in error && error.is_expired === true) {
          window.location.href = "/";
          localStorage.setItem("is_expired", "true");
        }
        sentryCaptureError(error, "Unauthorized request denied");
        break;
      case 403:
        const unauthorizedErrorData = await error.json();
        openToast(
          unauthorizedErrorData.message ||
            unauthorizedErrorData.error ||
            "You are not authorized to complete this action.",
          "error",
        );
        sentryCaptureError(error, "Not allowed to access this event");
        break;
      case 404:
        // Handle not found
        openToast(
          "We couldn't find the page or content you're looking for. Please check the URL or try again later.",
          "error",
        );
        sentryCaptureError(error, "Page not found");
        break;
      case 422: {
        const errorData = await error.json();
        openToast(
          errorData?.error ||
            "Something went wrong with the request. Please try again.",
          "error",
        );

        sentryCaptureError(error, "Something went wrong with the request");

        break;
      }
      case 500:
        // Handle server error
        openToast("Something wrong happened, please contact support.", "error");
        sentryCaptureError(error, "Something wrong happened");
        break;
      default:
        openToast("An error occurred. Please try again.", "error");
        sentryCaptureError(error, "An error occurred");
    }
  } else {
    openToast(
      error.message || error.error || "An error occurred. Please try again.",
      "error",
    );

    sentryCaptureError(error, "Unknown error");
  }
};

export const queryClientOptions: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: handleGlobalError,
      useErrorBoundary: true,
    },
    mutations: {
      onError: handleGlobalError,
      useErrorBoundary: false,
    },
  },
};
